import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';

import demppic from "../../assets/image/user-circle.svg"
import hat from '../../assets/image/cap-graduation.svg'
import Loader from '../../Components/Loader/Loader';
import Toastify from '../../utils/tostfy';

function TotalVisitedSchool() {


    const [totalPages, setTotalPages] = useState(0)
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [indexNumber, setIndexNumber] = useState(0)

    const [id, setId] = useState(0);
    const [user, setUser] = useState([]);
    const [nonVisited, setNonVisited] = useState([]);

    const [block, setBlock] = useState(false);
    const blockClose = () => setBlock(false);
    const [delet, setDelet] = useState(false);
    const deleteClose = () => setDelet(false);
    const location = useLocation()
    const [search, setSearch] = useState("");


    const navigate = useNavigate();
    useEffect(() => {
        getUserList()
    }, [])
    const paginationHandler = (e, i) => {
        e.preventDefault();
        console.log("iiii", i);
        if (i != page) {
            setPage(i);
            const newIndexNumber = perPage * (i - 1); // Calculate starting index for the page
            setIndexNumber(newIndexNumber);
            // CcrApiList({
            //     ...searchQuery,
            //     page: i,
            //     limit: perPage
            // })
        }
    };
    const getUserList = async () => {
        const response = await handleApiCall("get", `${endpoint.totalVisited}?page=${page}&limit=${perPage}&id=${location?.state?.coach?._id}${location?.state?.filter}`, {});
        try {
            console.log(response, "Visited")
            if (response?.data?.code === 200) {
                setUser(response?.data?.data?.visitedSchool);
                setNonVisited(response?.data?.data?.notVisitedSchool)

                setTotalPages(response?.data?.data?.total_pages);
                setTotal(response?.data?.data?.total);
            }
            if (response?.response?.data?.success === false) {
                toast.error(response?.response?.data?.errorMessage);
                setTimeout(() => { navigate("/") }, 2000);
            }
        } catch (e) {
            console.log("Error fetching data:", e);
        }
    };

    const goBack = () => {
        navigate(-1); // Navigates back to the previous page

    };

   
  

    return (
        <>
        <Toastify/>
            <div className=' flex gap-2 items-center'>
                <img src={location?.state?.coach?.image || demppic} alt="user" className="w-16 h-16 rounded-full" />
                <div className=' flex-col'>
                    <p className=' font-bold '>  {location?.state?.coach?.full_name} </p>

                </div>
            </div>
            <div className="common-table-wrapper m-0 ">

                <div className=" my-3">
                    <div className='flex-col gap-2 justify-start items-center'>
                        <h2 className=' mr-5 text-[30px]'>{""}</h2>

                    </div>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-8 sm:grid-cols-3 gap-3 my-2 ">


                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Region</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.region_name || "-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Country</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.country_name || "-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">State</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.state_name || "-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Dstrict</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.district_name || "-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Block</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.block_name || "-"}</span>
                    </div>

                </div>
                <div className=' flex  justify-between my-3 mt-5'>
                    <Link onClick={goBack} className="text-white bg-black hover:text-white outline-1 outline-double rounded-md text-sm font-semibold px-4 py-2 d-inline-block">Back</Link>

                </div>
                <p className=' mt-2 text-[12px] font-bold'>Visited Schools</p>

                {user?.length>0?<div className=' grid  md:grid-cols-4 gap-3 my-2  '>
                   {user?.map(school=>{
                    return(
                        <div className=' bg-[#787878] bg-opacity-10 rounded-md p-2 py-4 flex'>
                        <div className=' px-2'> <img src={hat} className=' h-7 w-7'></img></div>
                        <div>
                            <p className=' text-[14px] font-bold'>{school?.school_name}</p>
                            <p className=' text-[14px] font-semibold text-gray-500'>{school?.school_address}</p>
                        </div>

                    </div>
                    )
                   }) }
                </div>:<div className=' text-center font-bold'>No School Visited</div>}

                <p className=' mt-4 text-[12px] font-bold'>Non Visited Schools (Flagged)</p>
                {nonVisited?.length>0?
                <div className=' grid  md:grid-cols-4 gap-3 my-2  '>
                {nonVisited?.map(school=>{
                    return(
                        <div className=' bg-[#787878] bg-opacity-10 rounded-md p-2 py-4 flex'>
                        <div className=' px-2'> <img src={hat} className=' h-7 w-7'></img></div>
                        <div>
                            <p className=' text-[14px] font-bold'>{school?.school_name}</p>
                            <p className=' text-[14px] font-semibold text-gray-500'>{school?.school_address}</p>
                        </div>

                    </div>
                    )
                   }) }


                </div>:<div className=' text-center font-bold'>No Nono Visited School</div>}

            </div>

        </>
    )
}

export default TotalVisitedSchool